import { useEffect } from "react";

const APP_STORE_URL = "https://apps.apple.com/app/social-spectrum/id6473112455";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.social_spectrum.mobile";

export default function AppRedirect() {
    useEffect(() => {
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        const isAndroid = /Android/i.test(navigator.userAgent);

        if (isIOS) {
            window.plausible("App Store Click");
            window.location.href = APP_STORE_URL;
        } else if (isAndroid) {
            window.plausible("Play Store Click");
            window.location.href = PLAY_STORE_URL;
        } else {
            // Desktop users: send them to the "Our App" landing page
            window.location.href = "/ourapp";
        }
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-white">
            <div className="text-center">
                <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <p className="text-gray-600 font-medium">Redirecting to Store...</p>
            </div>
        </div>
    );
}
